import { render, staticRenderFns } from "./ComparableTableRow.vue?vue&type=template&id=1c0e10c7&scoped=true"
import script from "./ComparableTableRow.vue?vue&type=script&lang=js"
export * from "./ComparableTableRow.vue?vue&type=script&lang=js"
import style0 from "./ComparableTableRow.vue?vue&type=style&index=0&id=1c0e10c7&prod&lang=css"
import style1 from "./ComparableTableRow.vue?vue&type=style&index=1&id=1c0e10c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0e10c7",
  null
  
)

export default component.exports